function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { LikeButton } from './LikeButton';
import { CommentButton } from './CommentButton';
import { RetweetButton } from './RetweetButton';
import { BookmarkButton } from './BookmarkButton';
import { ViewCount } from './ViewCount';
import { ActionButtonsRow as StyledActionButtonsRow } from '../SocialActions.styles';
export var ActionButtons = function(param) {
    var // 상태
    liked = param.liked, retweeted = param.retweeted, bookmarked = param.bookmarked, showRetweetOptions = param.showRetweetOptions, retweetOptionsRef = param.retweetOptionsRef, // 카운트
    likesCount = param.likesCount, retweetsCount = param.retweetsCount, repliesCount = param.repliesCount, viewsCount = param.viewsCount, // 설정
    showBookmarkButton = param.showBookmarkButton, showRetweetButton = param.showRetweetButton, variant = param.variant, size = param.size, showCounts = param.showCounts, labels = param.labels, // 핸들러
    onLike = param.onLike, onRetweetClick = param.onRetweetClick, onRetweet = param.onRetweet, onQuoteTweet = param.onQuoteTweet, onComment = param.onComment, onBookmark = param.onBookmark;
    var buttonProps = {
        size: size,
        showCounts: showCounts,
        labels: labels
    };
    return /*#__PURE__*/ React.createElement(StyledActionButtonsRow, {
        size: size,
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center space-x-4 sm:space-x-6",
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, /*#__PURE__*/ React.createElement(LikeButton, _object_spread_props(_object_spread({}, buttonProps), {
        liked: liked,
        likesCount: likesCount,
        onLike: onLike
    })), /*#__PURE__*/ React.createElement(CommentButton, _object_spread_props(_object_spread({}, buttonProps), {
        repliesCount: repliesCount,
        onComment: onComment
    })), showRetweetButton && /*#__PURE__*/ React.createElement(RetweetButton, _object_spread_props(_object_spread({}, buttonProps), {
        retweeted: retweeted,
        retweetsCount: retweetsCount,
        showRetweetOptions: showRetweetOptions,
        retweetOptionsRef: retweetOptionsRef,
        onRetweetClick: onRetweetClick,
        onRetweet: onRetweet,
        onQuoteTweet: onQuoteTweet
    })), showBookmarkButton && variant === 'row' && /*#__PURE__*/ React.createElement(BookmarkButton, _object_spread_props(_object_spread({}, buttonProps), {
        bookmarked: bookmarked,
        variant: variant,
        onBookmark: onBookmark
    }))), /*#__PURE__*/ React.createElement(ViewCount, _object_spread_props(_object_spread({}, buttonProps), {
        viewsCount: viewsCount
    })));
};
